import { useEffect, useState } from 'react';

// same as TSA
export default function useConnectionStatus(socket, errorHandler) {
  const [connected, setConnected] = useState(false);
  useEffect(() => {
    socket.on('connect', () => {
      console.log('The socket has connected:', socket.id);
      setConnected(true);
    });

    socket.on('disconnect', (reason) => {
      console.log('The socket has disconnected:', reason);
      // socket.removeAllListeners();
      setConnected(false);
    });

    socket.on('reconnect', (attempt) => {
      console.log(`Successfully reconnected after ${attempt} attempts`);
      setConnected(true);
    });

    socket.on('reconnect_failed', () => {
      console.error('Failed to reconnect socket:', socket.id);
      setConnected(false);
    });

    socket.on('reconnect_failed', () => {
      console.error('Failed to reconnect socket:', socket.id);
      setConnected(false);
    });

    socket.on('connect_error', (err) => {
      console.error('Socket connect error', err.toString());
      typeof errorHandler === 'function' && errorHandler(socket, err);
      setConnected(false);
    });

    socket.on('error', (err) => {
      console.error('Socket', err.toString());
      typeof errorHandler === 'function' && errorHandler(socket, err);
      setConnected(false);
    });
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, []);

  return connected;
}
